import { ContentStackStore } from '../content-stack.store'
import { createCMSClient } from '../helpers/create-cms-client'

import { ConfigStore } from '@/stores/config'

export function getCMSClient() {
  let currentContentStackClient =
    ContentStackStore.getState().contentStackClient
  if (!currentContentStackClient) {
    currentContentStackClient = createCMSClient(ConfigStore.getState().stack)
    ContentStackStore.setState({
      contentStackClient: currentContentStackClient,
    })
  }
  return currentContentStackClient
}
